import {StringUtil} from "src/app/util/StringUtil";

export function generateReviewUrl(reviewId: string): string {
    if (!StringUtil.isNullOrEmpty(window.location.port)) {
        return "https://" + window.location.hostname + ":" + window.location.port + "/review/" + reviewId;
    } else {
        return "https://" + window.location.hostname + "/review/" + reviewId;
    }
}